import React from 'react';

interface WhatsAppIconProps {
  className?: string;
  size?: number;
  variant?: 'green' | 'white' | 'dark' | 'outline' | 'transparent';
}

export const WhatsAppIcon: React.FC<WhatsAppIconProps> = ({
  className = 'w-5 h-5',
  size,
  variant = 'green'
}) => {
  if (variant === 'outline' || variant === 'white' || variant === 'transparent') {
    return (
      <svg
        viewBox="0 0 24 24"
        width={size || 20}
        height={size || 20}
        className={className}
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.04 20.15C10.56 20.15 9.11 19.76 7.85 19.01L7.55 18.83L4.44 19.65L5.27 16.61L5.07 16.3C4.24 14.98 3.81 13.47 3.81 11.91C3.81 7.37 7.5 3.68 12.04 3.68C14.25 3.68 16.31 4.54 17.87 6.1C19.42 7.66 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15ZM16.56 14.28C16.31 14.16 15.1 13.56 14.88 13.48C14.65 13.4 14.49 13.36 14.32 13.6C14.16 13.85 13.68 14.41 13.53 14.57C13.39 14.74 13.24 14.76 13 14.64C12.75 14.51 11.71 14.17 10.49 13.08C9.53 12.23 8.89 11.17 8.76 10.95C8.64 10.73 8.75 10.6 8.87 10.48C8.98 10.37 9.12 10.19 9.24 10.05C9.37 9.91 9.41 9.81 9.49 9.64C9.57 9.48 9.53 9.33 9.47 9.21C9.41 9.09 8.92 7.89 8.72 7.39C8.52 6.9 8.32 6.97 8.16 6.96C8.02 6.95 7.86 6.95 7.69 6.95C7.53 6.95 7.26 7.01 7.04 7.26C6.81 7.5 6.19 8.08 6.19 9.27C6.19 10.45 7.05 11.6 7.17 11.76C7.3 11.92 8.87 14.34 11.27 15.38C11.84 15.63 12.28 15.77 12.63 15.88C13.2 16.07 13.72 16.04 14.13 15.98C14.59 15.91 15.54 15.4 15.74 14.84C15.94 14.28 15.94 13.8 15.88 13.69C15.82 13.6 15.67 13.53 15.42 13.41L16.56 14.28Z" />
      </svg>
    );
  }

  return (
    <div
      style={{ width: size || 24, height: size || 24 }}
      className={`rounded-full bg-[#25D366] flex items-center justify-center text-white shrink-0 ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        width={(size ? size * 0.65 : 15)}
        height={(size ? size * 0.65 : 15)}
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.04 20.15C10.56 20.15 9.11 19.76 7.85 19.01L7.55 18.83L4.44 19.65L5.27 16.61L5.07 16.3C4.24 14.98 3.81 13.47 3.81 11.91C3.81 7.37 7.5 3.68 12.04 3.68C14.25 3.68 16.31 4.54 17.87 6.1C19.42 7.66 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15ZM16.56 14.28C16.31 14.16 15.1 13.56 14.88 13.48C14.65 13.4 14.49 13.36 14.32 13.6C14.16 13.85 13.68 14.41 13.53 14.57C13.39 14.74 13.24 14.76 13 14.64C12.75 14.51 11.71 14.17 10.49 13.08C9.53 12.23 8.89 11.17 8.76 10.95C8.64 10.73 8.75 10.6 8.87 10.48C8.98 10.37 9.12 10.19 9.24 10.05C9.37 9.91 9.41 9.81 9.49 9.64C9.57 9.48 9.53 9.33 9.47 9.21C9.41 9.09 8.92 7.89 8.72 7.39C8.52 6.9 8.32 6.97 8.16 6.96C8.02 6.95 7.86 6.95 7.69 6.95C7.53 6.95 7.26 7.01 7.04 7.26C6.81 7.5 6.19 8.08 6.19 9.27C6.19 10.45 7.05 11.6 7.17 11.76C7.3 11.92 8.87 14.34 11.27 15.38C11.84 15.63 12.28 15.77 12.63 15.88C13.2 16.07 13.72 16.04 14.13 15.98C14.59 15.91 15.54 15.4 15.74 14.84C15.94 14.28 15.94 13.8 15.88 13.69C15.82 13.6 15.67 13.53 15.42 13.41L16.56 14.28Z" />
      </svg>
    </div>
  );
};
